import { Pipe, PipeTransform } from '@angular/core';
import { DateInput, toDate } from '@macs-frontend/core/utils/date-utils';

@Pipe({ name: 'toDate', pure: true })
export class ToDatePipe implements PipeTransform {
  public transform<T extends DateInput | null | undefined>(
    value: T,
  ): T extends DateInput ? Date : T {
    return toDate(value);
  }
}
